module.exports = __webpack_public_path__ + "media/images/icons/icon-carousel-next-9df00249263ecaaf5c65903eeb8222d3.svg";